import { Connection } from "../../model/connections/Connection.model"
import { ConnectionType } from "../../model/connections/ConnectionType.model"
import { ConnectionsCollection } from "../../model/connections/ConnectionsCollection.model"
import { RootState } from "../../root-redux/RootState"

export const connectionsSelector = (state: RootState): {connections: ConnectionsCollection, appScopes: string[]} => {
    const subscriptionKey = state.workflowById.workflow.subscriptionKey
    const connectionsObj = state.connections.list
    const appScopes = new Set<string>()

    if (connectionsObj) {
      Object.keys(connectionsObj).forEach((key: string) => {
        const connectionItems = connectionsObj[key]
        if (connectionItems) {
          Object.values(ConnectionType).forEach((value: ConnectionType) => {
            connectionItems[value]?.forEach((item: Connection) => {
                appScopes.add(item.appScope)
            })
          });
        }                
      })
    }   
    return {connections: connectionsObj[subscriptionKey], appScopes: [...appScopes]}
}